/**
 * The honest placeholder.
 *
 * Phases 3 and 4 are specified and not built. This screen says so, says what the capability will
 * do, and says what exists today instead — rather than rendering a convincing shell with seeded
 * numbers, which is the same lie as an unmarked mock and harder to spot because it is a whole page.
 */

import { Link } from "react-router-dom";
import { CAPABILITIES, NAV } from "@hub/core/browser";
import { Card } from "../components";

export function NotBuiltYet({ route }: { route: string }) {
  const entry = NAV.find((n) => n.route === route);
  const caps = CAPABILITIES.filter((c) => c.route === route);

  return (
    <>
      <div className="page-head">
        <div>
          <h1>{entry?.label ?? route}</h1>
          <p className="sub">
            Specified, not built. This build covers phases 0 to 2 — identity, credentialing and
            visibility. {entry?.label} is phase {entry?.phase}.
          </p>
        </div>
      </div>

      <div className="stack">
        <Card title="What this screen will do">
          {caps.length === 0
            ? <p className="sub">See <code>docs/SCREENS.md</code> for the specification.</p>
            : caps.map((c) => (
                <p key={c.id} className="sub" style={{ marginTop: 0 }}>{c.description}</p>
              ))}
        </Card>

        <Card title="What exists today">
          <p className="sub" style={{ marginTop: 0 }}>
            The policy package this screen will edit is already enforced — it lives in{" "}
            <code>policies/security/main.rego</code> and every credential request goes through it.
            The review cadences and the scorecard arithmetic are implemented and tested in{" "}
            <code>packages/core</code>. What is missing is the interface, not the behaviour.
          </p>
          <p className="sub">
            <Link to="/agents">Agents</Link> · <Link to="/access">Access management</Link> ·{" "}
            <Link to="/graph">Access graph</Link>
          </p>
        </Card>
      </div>
    </>
  );
}
